import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HeaderService } from 'src/app/header/service/header.service';

@Component({
  selector: 'app-redefinir-senha',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.scss']
})
export class RedefinirSenhaComponent implements OnInit {

  BASE_IMG_URL = environment.BASE_IMG_URL;

  form: FormGroup;
  token: string = '';
  isLoading  = false;
  submitted  = false;
  errorMessage = '';
  showPassword    = false;
  showConfirmPassword = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private headerService: HeaderService
  ) {
    this.form = this.fb.group({
      password:        ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordsMatch });
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') ?? '';

    if (!this.token) {
      this.errorMessage = 'Link inválido ou expirado.';
    }
  }

  get passwordControl()        { return this.form.get('password'); }
  get confirmPasswordControl() { return this.form.get('confirmPassword'); }

  togglePassword()        { this.showPassword = !this.showPassword; }
  toggleConfirmPassword() { this.showConfirmPassword = !this.showConfirmPassword; }

  passwordsMatch(group: AbstractControl): ValidationErrors | null {
    const pass    = group.get('password')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return pass === confirm ? null : { passwordsMismatch: true };
  }

  onSubmit(): void {
    if (this.form.invalid || !this.token) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading    = true;
    this.errorMessage = '';

    const payload = {
      token:    this.token,
      password: this.form.value.password
    };

    this.headerService.resetPassword(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response?.success) {
          this.submitted = true;
        } else {
          this.errorMessage = response?.message || 'Erro ao redefinir senha.';
        }
      },
      error: (err) => {
        this.isLoading = false;
        if (err.status === 400) {
          this.errorMessage = 'Link inválido ou expirado. Solicite um novo link.';
        } else {
          this.errorMessage = 'Não foi possível redefinir a senha. Tente novamente.';
        }
      }
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}